import API from '.';

export default class NuvoloService {
  static async getBuilding(buildingId) {
    const api = await API();
    const response = await api.get(
      `Nuvolo/Site?siteId=${buildingId}`
    );
    return response;
  }
}